import Link from 'next/link'
import ArrowIcon from '../../atoms/arrowIcon'
import { colors } from '../../atoms/colors'
import Name from './name'

const ArrowButton = ({
  name,
  link,
  type = 'link',
  size = 'small',
  color = 'primary',
  className = '',
  onClick,
  ...args
}) => {
  const base = 'w-fit flex items-center gap-x-[10px] font-chivoMono group'
  const textSizes = {
    small: 'text-smallButtonMobile md:text-smallButtonDesktop',
    big: 'text-bigButtonMobile md:text-bigButtonDesktop',
  }
  const buttonSizes = {
    small: 'w-[13px] h-[13px] md:w-[26px] md:h-[26px]',
    big: 'w-[16px] h-[16px] md:w-[31px] md:h-[31px]',
  }
  const textColor = {
    primary: 'text-umber decoration-umber',
    secondary: 'text-background decoration-background',
  }

  const arrowColor = {
    primary: colors.umber,
    secondary: colors.background,
  }

  const NameAndArrow = () => {
    return (
      <>
        <Name
          text={name}
          className={`${textSizes[size]} ${textColor[color]}`}
        />
        <ArrowIcon
          color={arrowColor[color]}
          className={`relative transition-all duration-500 ${buttonSizes[size]}`}
        />
      </>
    )
  }

  if (type === 'link') {
    return (
      <Link
        scroll={false}
        href={link}
        {...args}
        className={`${base} ${className}`}
      >
        <NameAndArrow />
      </Link>
    )
  } else if (type === 'button') {
    return (
      <button
        type="button"
        className={`cursor-pointer ${base} ${className}`}
        {...args}
        onClick={onClick}
      >
        <NameAndArrow />
      </button>
    )
  }
}

export default ArrowButton
